import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { Heading } from "../Heading";

import styles from "./TextImageTeaser.scss";

const TeaserHeading = forwardRef(({ children, variants, ...others }, ref) => {
  const headerClasses = classNames(styles.teaserHeading, variants);
  return (
    <Heading className={headerClasses} ref={ref} {...others}>
      {children}
    </Heading>
  );
});

const Variant = {
  xl: {
    primary: styles.headingXlPrimary,
    primaryDisplay: styles.headingXlPrimaryDisplay,
    primaryDisplayUppercase: styles.headingXlPrimaryDisplayUppercase,
    secondary: styles.headingXlSecondary,
    secondaryDisplay: styles.headingXlSecondaryDisplay,
    secondaryDisplayUppercase: styles.headingXlSecondaryDisplayUppercase,
  },
  l: {
    secondary: styles.headingLSecondary,
    secondaryDisplay: styles.headingLSecondaryDisplay,
    secondaryDisplayUppercase: styles.headingLSecondaryDisplayUppercase,
  },
  sm: {
    tertiary: styles.headingLTertiary,
    tertiaryDisplay: styles.headingSmTertiaryDisplay,
    tertiaryDisplayUppercase: styles.headingSmTertiaryDisplayUppercase,
  },
};

TeaserHeading.Variant = Variant;

TeaserHeading.propTypes = {
  children: PropTypes.node.isRequired,
  variants: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.string,
  ]),
};

TeaserHeading.defaultProps = {
  variants: [
    Variant.xl.primaryDisplay,
    Variant.l.secondaryDisplay,
    Variant.sm.tertiaryDisplay,
  ],
};

TeaserHeading.displayName = "TextImageTeaser.Heading";

export default TeaserHeading;
